// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"681":"6b2e14f8","6346":"ae4b1c27"}[chunkId] + ".chunk.css";
};